import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { selectBadge } from "@faire/retailer-visitor-shared/components/ProductBadge/badgeUtils";
import { ProductTileQuickAdd } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/__internal__/ProductTileQuickAdd";
import { TopBadges } from "@faire/retailer-visitor-shared/features/MarketplaceItems/TopBadges";
import { SaveToBoard } from "@faire/retailer-visitor-shared/features/RetailerBoards/Components/SaveToBoard";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/settings/useSettingPersistQuickAddOnSearchTile";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
export var PRODUCT_TILE_SURFACE;
(function(PRODUCT_TILE_SURFACE) {
    PRODUCT_TILE_SURFACE[PRODUCT_TILE_SURFACE["EVALUATE"] = 0] = "EVALUATE";
    PRODUCT_TILE_SURFACE[PRODUCT_TILE_SURFACE["DISCOVERY"] = 1] = "DISCOVERY";
    PRODUCT_TILE_SURFACE[PRODUCT_TILE_SURFACE["OTHER"] = 2] = "OTHER";
})(PRODUCT_TILE_SURFACE || (PRODUCT_TILE_SURFACE = {}));
export var TileImageOverlayContent = function(param) {
    var productTile = param.productTile, disableEventBadge = param.disableEventBadge, updateCartFn = param.updateCartFn, imageContainerRef = param.imageContainerRef, onTopLeftBadgeVisible = param.onTopLeftBadgeVisible, renderCollapsableQuickAddButtonProps = param.renderCollapsableQuickAddButtonProps, isSubscriedToBackInStock = param.isSubscriedToBackInStock, deleteBackInStockNotification = param.deleteBackInStockNotification, onHeartClicked = param.onHeartClicked, onSaveToBoard = param.onSaveToBoard, onRemoveFromBoard = param.onRemoveFromBoard, onQuickAdd = param.onQuickAdd, onQuickAddSubmit = param.onQuickAddSubmit, onChooseOption = param.onChooseOption, onChooseOptionQuantityUpdate = param.onChooseOptionQuantityUpdate, hideAddToCartAndNotifyMe = param.hideAddToCartAndNotifyMe, shouldHideSaveToBoard = param.shouldHideSaveToBoard, productTileSurface = param.productTileSurface;
    var _productTile_product, _productTile_badge_list;
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    var _useState = _sliced_to_array(useState(false), 2), hasHovered = _useState[0], setHasHovered = _useState[1];
    useEffect(function() {
        if ((imageContainerRef === null || imageContainerRef === void 0 ? void 0 : imageContainerRef.current) && isDesktopAndAbove) {
            var imageContainer = imageContainerRef.current;
            var handleMouseEnter = function() {
                setHasHovered(true);
            };
            imageContainer.addEventListener("mouseenter", handleMouseEnter, {
                once: true
            });
            return function() {
                imageContainer.removeEventListener("mouseenter", handleMouseEnter);
            };
        }
        return function() {};
    }, [
        imageContainerRef,
        isDesktopAndAbove
    ]);
    var marketStore = useMarketStore([
        "isLive"
    ]);
    var canSaveToBoard = isLoggedInRetailer() && shouldHideSaveToBoard !== true;
    var isSalesPaused = (productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.state) === IProduct.State.SALES_PAUSED;
    var topBadge = useMemo(function() {
        var _productTile_badge_list;
        var _productTile_badge_list_badges;
        var productBadges = (_productTile_badge_list_badges = productTile === null || productTile === void 0 ? void 0 : (_productTile_badge_list = productTile.badge_list) === null || _productTile_badge_list === void 0 ? void 0 : _productTile_badge_list.badges) !== null && _productTile_badge_list_badges !== void 0 ? _productTile_badge_list_badges : [];
        return selectBadge(productBadges, "TOP");
    }, [
        productTile === null || productTile === void 0 ? void 0 : (_productTile_badge_list = productTile.badge_list) === null || _productTile_badge_list === void 0 ? void 0 : _productTile_badge_list.badges
    ]);
    var hideMarketBadge = disableEventBadge && marketStore.isLive;
    var showEventBadge = (productTile === null || productTile === void 0 ? void 0 : productTile.is_highlighted_product_for_promotional_event) && !hideMarketBadge;
    var persistQuickAdd = useSettingPersistQuickAddOnSearchTile() && isLoggedInRetailer();
    var shouldShowQuickAdd = persistQuickAdd ? productTile && !hideAddToCartAndNotifyMe : productTile && !hideAddToCartAndNotifyMe && hasHovered;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isSalesPaused ? /*#__PURE__*/ _jsx(BackorderedOverlay, {}) : null,
            (productTile === null || productTile === void 0 ? void 0 : productTile.product) ? /*#__PURE__*/ _jsx(TopBadges, {
                tileBadge: topBadge,
                showEventBadge: showEventBadge,
                onTopLeftBadgeVisible: onTopLeftBadgeVisible,
                favoriteButton: canSaveToBoard ? /*#__PURE__*/ _jsx(SaveToBoard, {
                    "data-test-id": "favorite-button",
                    productToken: productTile.product.token,
                    productImage: productTile.best_image,
                    boardTokens: productTile.product.board_tokens,
                    brandToken: productTile.product.brand_token,
                    onHeartClicked: onHeartClicked,
                    onSaveToBoard: onSaveToBoard,
                    onRemoveFromBoard: onRemoveFromBoard
                }, "".concat(productTile.product.token, "-favorite")) : null
            }, "top-badges") : null,
            shouldShowQuickAdd && productTile ? /*#__PURE__*/ _jsx(ProductTileQuickAdd, {
                productTile: productTile,
                updateCartFn: updateCartFn,
                imageContainerRef: imageContainerRef,
                renderCollapsableQuickAddButtonProps: renderCollapsableQuickAddButtonProps,
                isSubscriedToBackInStock: isSubscriedToBackInStock,
                deleteBackInStockNotification: deleteBackInStockNotification,
                onQuickAdd: onQuickAdd,
                onQuickAddSubmit: onQuickAddSubmit,
                onChooseOption: onChooseOption,
                onChooseOptionQuantityUpdate: onChooseOptionQuantityUpdate,
                productTileSurface: productTileSurface
            }) : null
        ]
    });
};
var BackorderedOverlay = styled(TransparencyOverlay).withConfig({
    componentId: "sc-6875fcce-0"
})([
    "background:rgba(255,255,255,0.5);"
]);
